import React, { useContext, useEffect, useRef, useState } from 'react';
import StepLocationDetails from './StepLocationDetails';
import StepCribSheet from './StepCribSheet';
import StepAddPhotos from './StepAddPhotos';
import LocationCreated from './LocationCreated';
import { useForm } from 'react-hook-form';
import { createLocationFormData } from '../../../data/formData';
import { apiConstants } from '../../../utils/apiConstants';
import { emptyFunction, getCompanyName, showToast, validatePhoneNumber } from '../../../utils';
import { makeGetCall, makePostCall } from '../../../effects/requests';
import { endPoints } from '../../../utils/endpoints';
import { ApiResponseType } from '../../../types';
import { errorMessage } from '../../../utils/constants';
import { DateUtils } from '../../../utils/dateUtils';
import { MyContext } from '../../../context';
import { instance } from '../../../utils/axios';
import { UploadContext } from '../../../context/UploadContext';
interface Props {
    onClose: () => void;
    onDone: () => void;
    vaultType?: any
}

type Step = 1 | 2 | 3;

const CreateLocation: React.FC<Props> = ({ onClose, onDone, vaultType }) => {

    const { updateUploadProgress } = useContext(UploadContext);

    const addPhotoRef = useRef<any>(null);

    const { userData } = useContext(MyContext)

    const locationId = ''

    const [step, setStep] = useState<Step>(1);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [view, setView] = useState<any>('galleries');
    const [cribEntries, setCribEntries] = useState<any>([]);
    const [folderEntries, setFolderEntries] = useState<any>([]);

    const { ...createLocData } = useForm({
        mode: 'all',
        defaultValues: { ...createLocationFormData() },
        reValidateMode: 'onBlur',
    });

    const handleNext = async () => {
        switch (step) {
            case 1:
                const isValid = await createLocData.trigger([
                    apiConstants.name,
                    // apiConstants.address,
                    // apiConstants.contact_person,
                    // apiConstants.contact_email,
                    // apiConstants.contact_phone_number,
                    // apiConstants.shoot_rate,
                    // apiConstants.date_scouted,
                ]);
                if (!isValid) return;
                setStep((prev) => (prev + 1) as Step);
                break;

            case 2:
                const hasValidEntry = cribEntries.some((item: any) => item?.[apiConstants.headline]?.trim() !== "" && item?.[apiConstants.description]?.trim() !== "");
                // if (!hasValidEntry) {
                //     showToast("Please add at least one crib sheet.", 'error');
                //     return;
                // }
                setStep((prev) => (prev + 1) as Step);
                setView('galleries')
                break;

            case 3:
                if (view == 'new-folder') {
                    addPhotoRef?.current?.handleCreateFolder();
                    return
                }
                // if (folderEntries?.length <= 0) {
                //     showToast("Please add at least one folder and images.", 'error');
                //     return;
                // }
                handleSaveCreate(false)
                break;

            default:
        }
    };

    const handleSaveCreate = (isDraft: boolean) => {
        const createLocPayload: any = { ...createLocData.getValues() };
        if (createLocPayload[apiConstants.contact_phone_number]) {
            createLocPayload[apiConstants.contact_phone_number] = `${createLocPayload?.dial_code?.dial_code}${createLocPayload?.[apiConstants.contact_phone_number]}`;
            if (!validatePhoneNumber(createLocPayload?.[apiConstants.contact_phone_number])) {
                showToast(errorMessage.invalid_mobile_msg, 'error', 'mobile')
                return
            }
        }
        createLocPayload[apiConstants.date_scouted] = createLocPayload[apiConstants.date_scouted] ? DateUtils.formatDateTime(createLocPayload[apiConstants.date_scouted], 'YYYY-MM-DD') : ''
        // createLocPayload.is_draft = isDraft;
        createLocPayload.production_company_name = getCompanyName(userData);
        delete createLocPayload.dial_code;
        if (vaultType == 'myvault') {
            createLocPayload.my_vault = true
        }
        createLoc(createLocPayload)
    };

    const createLoc = (payload: any) => {
        makePostCall(endPoints.LOCATION, payload).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                createCrib(res?.data?.id)
            }
        }).catch(emptyFunction);
    }

    const createCrib = (locationID: any) => {
        if (cribEntries?.length > 0) {
            for (let i = 0; i < cribEntries?.length; i++) {
                const payload = {
                    location_id: locationID,
                    headline: cribEntries?.[i]?.headline || '',
                    description: cribEntries?.[i]?.description || '',
                    production_company_name: getCompanyName(userData),
                }
                makePostCall(endPoints.LOCATION_CRIB, payload).then((res: ApiResponseType<any>) => {
                    if (res?.status?.code === 200) {
                        if (i == cribEntries?.length - 1) {
                            if (folderEntries?.length > 0) {
                                createFolderAndImages(locationID)
                            } else {
                                setShowConfirmModal(false)
                                setShowSuccessModal(true);
                            }
                        }
                    }
                }).catch(emptyFunction);
            }
        } else {
            if (folderEntries?.length > 0) {
                createFolderAndImages(locationID)
            } else {
                setShowConfirmModal(false)
                setShowSuccessModal(true);
            }
        }
    }

    // const createFolderAndImages = async (locationID: any) => {
    //     try {
    //         for (const folder of folderEntries) {
    //             const folderPayload = {
    //                 location_id: locationID,
    //                 name: folder.name || "",
    //                 production_company_name: getCompanyName(userData),
    //             };

    //             const folderRes = await makePostCall(endPoints.LOCATION_FOLDER, folderPayload);

    //             if (folderRes?.status?.code !== 200) {
    //                 throw new Error("Folder creation failed");
    //             }

    //             const folderId = folderRes?.data?.id;

    //             // 2. Upload all images of this folder one by one
    //             for (const image of folder?.photos) {

    //                 const fd = new FormData();
    //                 fd.append('folder_id', folderId);
    //                 fd.append('image', image?.file);
    //                 fd.append('production_company_name', getCompanyName(userData));

    //                 const imageRes = await makePostCall(endPoints.LOCATION_FOLDER_IMAGE, fd);

    //                 if (imageRes?.status?.code !== 200) {
    //                     throw new Error("Image upload failed");
    //                 }
    //             }
    //         }

    //         // Executed only after ALL folders and ALL images are uploaded;
    //         setShowConfirmModal(false)
    //         setShowSuccessModal(true);
    //     } catch (error) {
    //         console.error(error);
    //     }
    // };

    const makePostCallWithProgress = async (
        url: string,
        apiPayload: object = {},
        isToast: boolean = false,
        onUploadProgress?: (progressEvent: any) => void
    ) => {
        const response: ApiResponseType = await instance.post(url, apiPayload, {
            onUploadProgress,
            options: {
                hideGlobalLoader: true
            }
        });

        const statusCode = response?.status?.code;
        const message = response?.status?.message;

        if (message && isToast && statusCode === 200) {
            showToast(message, "success");
        }

        return response;
    };

    const createFolderAndImages = async (locationID: any) => {
        // Close confirmation modal
        setShowConfirmModal(false)
        setShowSuccessModal(true);

        const totalImages = folderEntries.reduce(
            (count: number, folder: any) =>
                count + (folder.photos?.length || 0),
            0
        );

        let completedImages = 0;

        // Show upload progress modal
        updateUploadProgress({
            uploading: true,
            visible: true,
            percentage: 0,
            uploaded: 0,
            total: totalImages,
            status: "uploading",
            message: "Preparing upload...",
        });

        try {
            for (const folder of folderEntries) {
                const folderPayload = {
                    location_id: locationID,
                    name: folder.name || "",
                    production_company_name: getCompanyName(userData),
                };

                const folderRes = await makePostCall(
                    endPoints.LOCATION_FOLDER,
                    folderPayload
                );

                if (folderRes?.status?.code !== 200) {
                    throw new Error("Folder creation failed.");
                }

                const folderId = folderRes?.data?.id;

                for (const image of folder.photos) {
                    const fd = new FormData();

                    fd.append("folder_id", folderId);
                    fd.append("image", image.file);
                    fd.append(
                        "production_company_name",
                        getCompanyName(userData)
                    );
                    fd.append("thumbnail", image?.thumbnail || false);

                    const imageRes = await makePostCallWithProgress(
                        endPoints.LOCATION_FOLDER_IMAGE,
                        fd,
                        false,
                        (progressEvent) => {
                            if (!progressEvent.total) return;

                            const currentFileProgress =
                                progressEvent.loaded /
                                progressEvent.total;

                            const overallProgress =
                                (
                                    (completedImages +
                                        currentFileProgress) /
                                    totalImages
                                ) * 100;

                            updateUploadProgress({
                                percentage: Math.round(overallProgress),
                                uploaded: completedImages,
                                message: `Uploading ${completedImages + 1} of ${totalImages}...`,
                            });
                        }
                    );

                    if (imageRes?.status?.code !== 200) {
                        throw new Error("Image upload failed.");
                    }

                    completedImages++;

                    updateUploadProgress({
                        percentage: Math.round(
                            (completedImages / totalImages) * 100
                        ),
                        uploaded: completedImages,
                        message: `Uploaded ${completedImages} of ${totalImages}`,
                    });
                }
            }

            // Success state
            updateUploadProgress({
                uploading: false,
                percentage: 100,
                uploaded: totalImages,
                total: totalImages,
                status: "success",
                message: "Images uploaded successfully.",
            });

            // Wait 2 seconds so user can see success
            setTimeout(() => {
                updateUploadProgress({
                    uploading: false,
                    visible: false,
                    percentage: 0,
                    uploaded: 0,
                    total: 0,
                    status: "uploading",
                    message: "",
                });

                // Refresh your list if required
                // fetchFolders();

                // Clear local data if required
                // setFolderEntries([]);
            }, 3000);
        } catch (error: any) {
            console.error(error);

            updateUploadProgress({
                uploading: false,
                status: "error",
                message: error?.message || "Something went wrong while uploading.",
            });

            setTimeout(() => {
                updateUploadProgress({
                    uploading: false,
                    visible: false,
                    percentage: 0,
                    uploaded: 0,
                    total: 0,
                    status: "uploading",
                    message: "",
                });
            }, 3000);
        }
    };

    const handleSuccessClose = () => {
        setShowSuccessModal(false);
        onDone();
    };

    const fetchCribs = () => {
        const params = { location_id: locationId }
        makeGetCall(endPoints.LOCATION_CRIB, params).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                setCribEntries([])
            }
        }).catch(emptyFunction)
    }

    const fetchFolders = () => {
        const url = `${endPoints.LOCATION_FOLDER}?location_id=${locationId || ''}`
        makeGetCall(url).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                setCribEntries([])
            }
        }).catch(emptyFunction)
    }

    useEffect(() => {
        if (locationId) {
            fetchCribs();
        }
    }, [locationId]);

    return (
        <>
            {/* Backdrop */}
            <div className="cl-backdrop" />

            {/* Drawer panel */}
            <div className="cl-drawer">

                {/* Header */}
                <div className="cl-drawer__header">
                    <button className="cl-drawer__close" onClick={onClose}>
                        <img src='/assets/images/dismiss.svg' alt='close' />
                    </button>
                    <h2 className="cl-drawer__title">Create Location</h2>
                </div>

                {/* Step content */}
                <div className="cl-drawer__body">
                    {step === 1 &&
                        <StepLocationDetails
                            createLocData={createLocData}
                        />
                    }
                    {step === 2 &&
                        <StepCribSheet
                            entries={cribEntries}
                            setEntries={setCribEntries}
                            onRefresh={fetchCribs}
                        />
                    }
                    {step === 3 &&
                        <StepAddPhotos
                            setFolderEntries={setFolderEntries}
                            folderEntries={folderEntries}
                            setView={setView}
                            onRefresh={fetchFolders}
                            view={view}
                            ref={addPhotoRef}
                        />
                    }
                </div>

                {/* Footer: dots + action button */}
                <div className="cl-drawer__footer">
                    <div className="cl-dots">
                        {[1, 2, 3].map((s: any) => (
                            <span
                                onClick={() => {
                                    if (step > s) setStep(s)
                                }}
                                key={s}
                                className={`cl-dot${step === s ? ' cl-dot--active' : ''}`}
                            />
                        ))}
                    </div>
                    <button className="cl-btn-next" onClick={handleNext}>
                        {view == 'new-folder' ? 'Create Folder' : step < 3 ? 'Next' : 'Save & Create'}
                    </button>
                </div>
            </div>

            {/* Modals */}
            {showConfirmModal && (
                <LocationCreated
                    variant="confirm"
                    onYes={() => handleSaveCreate(true)}
                    onNo={() => handleSaveCreate(false)}
                    onClose={() => setShowConfirmModal(false)}
                />
            )}
            {showSuccessModal && (
                <LocationCreated
                    variant="success"
                    onClose={handleSuccessClose}
                />
            )}
        </>
    );
};

export default CreateLocation;